import {Action} from '../types/common';

export const CLOSE_MODAL_ACTION: Action = {
    name: 'CLOSE_MODAL_ACTION',
    action: (isFirstModal = true) => ({
        isFirstModal,
        type: CLOSE_MODAL_ACTION.name
    })
};

export const OPEN_MODAL_DATA_ACTION: Action = {
    name: 'OPEN_MODAL_DATA_ACTION',
    action: (header, content, footer, options) => ({
        header, content, footer, options,
        type: OPEN_MODAL_DATA_ACTION.name
    })
};
